export const MANAGER_VENDORS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/vendors", name: "Vendors" },
];

export const vendorsTableHeaders = ["Vendor Id", "Logo", "Name", "Address"];
